import React, { useState } from "react";
import MemoryMarkdown from "../../AgentMemory/MemoryMarkdown";

/**
 * Markdown-aware field: Preview (rendered) + Raw (editable textarea).
 * Used for agent description / how_it_works / launch_prompt and skill bodies.
 */
function MarkdownField({
  label,
  value,
  onChange,
  rows = 6,
  hint,
  mono = false,
  minHeightClass = "",
}) {
  const [mode, setMode] = useState("preview"); // preview | raw
  const hasContent = Boolean((value || "").trim());

  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-1">
        {label ? (
          <label className="block text-body-xs font-medium text-text-secondary">
            {label}
          </label>
        ) : (
          <span />
        )}
        <div className="flex items-center gap-1 rounded-lg overflow-hidden border border-border-subtle">
          {[
            { id: "preview", label: "Preview" },
            { id: "raw", label: "Raw" },
          ].map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setMode(t.id)}
              className={`px-2.5 py-1 text-[11px] font-medium transition-colors ${
                mode === t.id
                  ? "bg-button-primary text-white"
                  : "bg-white text-text-secondary hover:bg-surface-neutral"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {hint && (
        <p className="text-caption text-text-tertiary mb-1.5">{hint}</p>
      )}
      {mode === "preview" ? (
        <div
          className={`border border-border-subtle rounded-xl px-4 py-3 bg-white overflow-auto ${
            minHeightClass || "min-h-[120px] max-h-[420px]"
          }`}
        >
          {hasContent ? (
            <MemoryMarkdown text={value || ""} />
          ) : (
            <p className="text-body-xs text-text-tertiary py-6 text-center">
              Empty — switch to Raw to edit
            </p>
          )}
        </div>
      ) : (
        <textarea
          value={value || ""}
          onChange={(e) => onChange?.(e.target.value)}
          rows={rows}
          className={`w-full px-3 py-2.5 border border-border-subtle rounded-xl text-body-sm focus:outline-none focus:ring-2 focus:ring-accent-purple/20 ${
            mono ? "font-mono text-body-xs" : ""
          } ${minHeightClass}`}
        />
      )}
    </div>
  );
}

export default MarkdownField;
